import styled from 'styled-components'

export const NoResultObjectContainer = styled.div`
  position: relative;
  justify-content: center;
  text-align: center;
`
